import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import leftArrow from 'src/assets/images/left_arrow.svg';
import { setTextQuery } from 'src/redux/slices/open_ai';
import { PDF_PROMPT_SUGGESTIONS } from 'src/common/constants';

import styles from './index.module.scss';

interface WelcomeMessageProps {
    customStyle?: any;
    displaySuggestions?: boolean;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = (props) => {
    const dispatch = useDispatch();
    const { customStyle = {}, displaySuggestions = false } = props;

    const appType = useMemo(() => {
        const app = localStorage.getItem('app');
        return app;
    }, [localStorage.getItem('app')]);

    return (
        <div className={styles.welcome_container} style={customStyle}>
            <span className={styles.heading}>Welcome to {`${appType === 'zymedelite' ? 'ZyMedAI' : 'Tatva AI'}`}</span>
            <p className={styles.desc}>
                Welcome to {`${appType === 'zymedelite' ? 'ZyMedAI' : 'Tatva AI'}`}, your innovative platform designed to revolutionize the way doctors interact with medical information. Seamlessly chat with your medical PDFs and research papers, asking relevant questions to instantly extract crucial information. Retrieve patient histories, treatment protocols, drug details, and the latest research findings in real-time. Enhance decision-making, streamline patient care, and elevate the precision and quality of your practice with this dynamic, interactive resource. Embrace the future of medical practice today!
            </p>
            {displaySuggestions
                ? <>
                    <p className={styles.desc} style={{ color: '#171725', fontWeight: 400 }}>You can ask any question in the chatbox below or click one of the following examples:</p>
                    <div className={styles.suggestion_wrapper}>
                        {PDF_PROMPT_SUGGESTIONS.map((suggestion) => (
                            <div className={styles.suggestion_box}>
                                <img src={leftArrow} style={{ height: '24px' }} />
                                <div className={styles.suggestion_text} onClick={() => dispatch(setTextQuery(suggestion))}>{suggestion}</div>
                            </div>
                        ))}
                    </div>
                </>
                : <p className={styles.desc}>
                    Please upload or drop your document on the left side. Tatva AI will process it, allowing you to ask anything related to the PDF content.
                </p>
            }

            <span className={styles.heading}>Important Tips</span>
            <ul>
                <li className={styles.tip_list}>To ask a follow-up question, include context from previous messages in your prompt. Tatva AI does not look back at previous messages.</li>
                <li className={styles.tip_list}>Retrieve patient histories, treatment protocols, and drug details in real-time for quick access.</li>
                <li className={styles.tip_list}>Instantly extract crucial information from your medical PDFs and research papers by asking relevant questions.</li>
                <li className={styles.tip_list}>Enhance your decision-making process and streamline patient care with this interactive resource.</li>
                <li className={styles.tip_list}>Ensure precision and quality in your practice by using Tatva AI's dynamic capabilities.</li>
            </ul>
        </div>
    );
};

export default WelcomeMessage;
